
import React from 'react';

interface ListItemProps {
  Item: string;
}

const SingleListItem: React.FC<ListItemProps> = ({ Item }) => {
  return <div>{Item}</div>;
};

export default SingleListItem;
